<script lang="ts">

  import {
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TableHeader,
    TableRow,
  } from "$lib/components/ui/table"
  import type { OrderHistory } from "./../../_types"

  let {
    value,
  }: {
    value: OrderHistory
  } = $props()

</script>

<div class="overflow-x-auto">
  <Table>
    <TableHeader>
      <TableRow>
        <TableHead class="min-w-40">Produk</TableHead>
        {#each value.columns as column (column.type + column.date)}
          <TableHead class="text-right whitespace-nowrap">
            {column.type === "year" ? `Total ${column.date.toDateFormat("yyyy")}` : column.date.toDateFormat("MMM yy")}
          </TableHead>
        {/each}
        <TableHead class="text-right">Total</TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      {#each value.groups as group (group.id)}
        <TableRow>
          <TableCell class="font-medium bg-muted">{group.name}</TableCell>
          {#each group.values as number, index (index)}
            <TableCell class="text-right tabular-nums font-medium bg-muted">
              {number === 0 ? "-" : number.toLocaleString("en-US")}
            </TableCell>
          {/each}
          <TableCell class="text-right tabular-nums font-medium bg-muted">
            {group.total === 0 ? "-" : group.total.toLocaleString("en-US")}
          </TableCell>
        </TableRow>
        {#each group.products as product (product.id)}
          <TableRow>
            <TableCell>
              <div class="text-sm">{product.name}</div>
              <div class="text-xs text-muted-foreground">{product.number} | {product.unit}</div>
            </TableCell>
            {#each product.values as number, index (index)}
              <TableCell class="text-right tabular-nums">
                {number === 0 ? "-" : number.toLocaleString("en-US")}
              </TableCell>
            {/each}
            <TableCell class="text-right tabular-nums">
              {product.total === 0 ? "-" : product.total.toLocaleString("en-US")}
            </TableCell>
          </TableRow>
        {/each}
      {/each}
    </TableBody>
    <TableFooter>
      <TableRow>
        <TableCell class="font-semibold">Total</TableCell>
        {#each value.values as number, index (index)}
          <TableCell class="text-right tabular-nums font-semibold">
            {number === 0 ? "-" : number.toLocaleString("en-US")}
          </TableCell>
        {/each}
        <TableCell class="text-right tabular-nums font-semibold">
          {value.total === 0 ? "-" : value.total.toLocaleString("en-US")}
        </TableCell>
      </TableRow>
    </TableFooter>
  </Table>
</div>
